import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconExpandUncollapse = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3064 1.06514C12.2129 1.02328 12.1091 1 12 1C11.8952 1 11.7955 1.02145 11.7049 1.06021C11.6198 1.09651 11.5401 1.14925 11.4705 1.2184L11.4689 1.22001L7.21999 5.4689C6.92667 5.76223 6.92667 6.2378 7.21999 6.53112C7.51332 6.82445 7.98889 6.82445 8.28222 6.53112L11.2489 3.56444V9.49781C11.2489 9.91263 11.5852 10.2489 12 10.2489C12.4148 10.2489 12.7511 9.91263 12.7511 9.49781V3.56446L15.7178 6.53113C16.0111 6.82445 16.4867 6.82445 16.78 6.53113C17.0733 6.2378 17.0733 5.76223 16.78 5.4689L12.5311 1.22001C12.5199 1.20881 12.5084 1.19803 12.4967 1.18769L12.3064 1.06514Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.766 12.0099C4.76807 12.4192 5.10061 12.7497 5.50986 12.7493L18.4561 12.737C18.8646 12.7367 19.1963 12.4066 19.1985 11.998C19.2008 11.5857 18.867 11.2503 18.4547 11.2507L5.50845 11.263C5.09682 11.2634 4.76392 11.5983 4.766 12.0099Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3064 22.9338C12.2129 22.9756 12.1091 22.9989 12 22.9989C11.8952 22.9989 11.7955 22.9775 11.7049 22.9387C11.6198 22.9024 11.5401 22.8497 11.4705 22.7805L11.4689 22.7789L7.21999 18.53C6.92667 18.2367 6.92667 17.7611 7.21999 17.4678C7.51332 17.1745 7.98889 17.1745 8.28222 17.4678L11.2489 20.4345V14.5011C11.2489 14.0863 11.5852 13.75 12 13.75C12.4148 13.75 12.7511 14.0863 12.7511 14.5011V20.4345L15.7178 17.4678C16.0111 17.1745 16.4867 17.1745 16.78 17.4678C17.0733 17.7611 17.0733 18.2367 16.78 18.53L12.5311 22.7789C12.5199 22.7901 12.5084 22.8009 12.4967 22.8112L12.3064 22.9338Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconExpandUncollapse as ReactComponent };
